export default "__VITE_ASSET__CXAmSjJO__"